let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("pJMzj")).then(() => parcelRequire('5X6Mk'));